import "../css/components.css"
import "../css/responsee.css"
import "../css/template-style.css"
//import "../css/web-search.css"
import "../css/custom.css"

// Our modules / classes
import GoogleMap from "./modules/GoogleMap"
import Responsee from "./modules/responsee"
import PluginMin from "./modules/plugins.min"
import Lightcase from "./modules/lightcase"
import JqueryCountTo from "./modules/jquery.countTo"
import TemplateScripts from "./modules/template-scripts"
// Instantiate a new object using our modules/classes
var googleMap = new GoogleMap()
var responsee = new Responsee()
var pluginmin = new PluginMin()
var lightcase = new Lightcase()
var jquerycountto = new JqueryCountTo()
var templatescripts = new TemplateScripts()
